import { ElementsFactories } from 'react-planner';

const info = {
  title: 'L Shape',
  tag: ['shape'],
  description: 'L Shape',
  image: require('./area-l-shape.png')
};

export default ElementsFactories.AreaFactory('area-l', info);
